/* eslint-disable */
import { cloneLoop } from '@/shared/jsmini-clone/index'
import { toHump } from '@tencent/magic-ui-util'

import { value as app } from '../../packages/app'
import { value as page } from '../../packages/page'
import { value as container } from '../../packages/container'
import { value as pcContainer } from '../../packages/pc-container'
import { value as pop } from '../../packages/pop'
import { value as tabs, tabPaneValue as tabPane, tabNavValue as tabNav } from '../../packages/tabs'
import { value as text } from '../../packages/text'
import { value as link } from '../../packages/link'
import { value as image } from '../../packages/image'
import { value as qrCode } from '../../packages/qrcode'
import { value as video } from '../../packages/video'
import { value as actionButton } from '../../packages/button'

let CommonComponent = {
  app: app,
  page: page,
  container: container,
  pcContainer: pcContainer,
  pop: pop,
  tabs: tabs,
  tabPane: tabPane,
  tabNav: tabNav,
  text: text,
  link: link,
  image: image,
  video: video,
  qrCode: qrCode,
  actionButton: actionButton,
}

// 获取不同端的活动页面下的组件初始值
const getPageTypeComponentInitValue = (options = {}) => {
  const { pageType } = options;
  // pc端下，对每个组件的宽高和位置数据默认打开使用百分比选项
  if (pageType === 'PC') {
    return {
      style: {
        // 组件宽高使用百分比
        isSizeUsePercent: true,
        // 组件位置使用百分比
        isPositionUsePercent: false,
      }
    }
  }
  return {
    style: {}
  }
}

export default {
  CommonComponent,
  getValue (type, config = {}, id, options) {
    console.log('[ui] getValue', type, config, id, options);
    id = config.id || id || 0
    let humpType = toHump(type)
    const pageTypeComponentInitStyle = getPageTypeComponentInitValue(options).style;
    if (humpType === 'actionArea') {
      let compConfig = cloneLoop(CommonComponent['actionButton'])
      compConfig.style.backgroundColor = 'rgba(0, 0, 0, 0)'
      compConfig.style.color = 'rgba(0, 0, 0, 0)'
      compConfig.style = {
        ...compConfig.style,
        ...pageTypeComponentInitStyle
      }
      return Object.assign(compConfig, {
        type: 'action-button',
        text: '',
        className: 'action-area',
        name: '热区'
      } , config)
    } else if (type === 'magic') {
      const result = Object.assign({
        type: config.type,
        name: config.name,
        text: config.name,
        modId: config.modId,
        style: config.type.endsWith('button') ? cloneLoop(CommonComponent.actionButton.style) : {}
      }, cloneLoop(CommonComponent[toHump(config.type)]))
      result.style = {...pageTypeComponentInitStyle, ...(result.style || {})};
      return result;
    } else if (Object.keys(CommonComponent).includes(humpType)) {
      let compConfig = cloneLoop(CommonComponent[humpType])
      const result = Object.assign(compConfig, {
        type,
        name: compConfig.name || type
      }, config);
      result.style = {...pageTypeComponentInitStyle, ...(result.style || {})};
      return result;
    } else {
      return {
        name: `${type}`,
        type: type,
        style: {}
      } // 自定义模块 type要求唯一,组件名为 magic-ui-${type} todo 默认参数
    }
  }
}
